import script from "./ProjectInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectInfo.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectInfo.vue?vue&type=style&index=0&id=6edf4740&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6edf4740"]])

export default __exports__